/* eslint-disable react/no-array-index-key */
import { FC } from 'react';
import { ContainedSelect } from 'components/common';
import { Typography } from '@mui/material';
import { optionsForSelects } from 'pages/Notifications/types/NotificationsTypes';
import { BasketIcon } from 'components/Icons/BasketIcon';
import { translate } from 'localizations';
import UniversalButton from '../../Buttons/UniversalButton/UniversalButton';
import cls from './styles.module.scss';
import { useDynamicSelects } from '../hooks/useDynamicSelects';

interface DynamicSelectsProps {
	blockTitle: string;
	leftSelectTitle: string;
	rightSelectTitle: string;
	options?: optionsForSelects[];
	tagNamesWithValues?: string[];
	initialValue?: any;
	onChange?: (value: any) => void;
}

export interface SelectDataItem {
	leftSelected: any;
	rightSelected: any;
	leftOptions: optionsForSelects[] | undefined;
	rightOptions: optionsForSelects[] | undefined;
}

const DynamicSelects: FC<DynamicSelectsProps> = (props) => {
	const {
		blockTitle,
		leftSelectTitle,
		rightSelectTitle,
		options = [],
		tagNamesWithValues,
		initialValue,
		onChange,
	} = props;

	const { dynamicSelectsData, dynamicSelectsMathods } = useDynamicSelects({
		options,
		initialValue,
		onChange,
		tagNamesWithValues,
	});
	const { selectData, lang } = dynamicSelectsData;
	const { handleSelectChange, handleRemove, handleAdd } = dynamicSelectsMathods;

	return (
		<div className={cls.root}>
			<Typography className={cls.blockTitle}>{blockTitle}</Typography>

			{selectData.length > 0 && (
				<div className={cls.selectBlockHeader}>
					<div className={cls.leftSelectTitle}>{leftSelectTitle}</div>
					<div className={cls.rightSelectTitle}>{rightSelectTitle}</div>
				</div>
			)}

			{selectData.map((data, index) => (
				<div key={`${data.leftSelected.value}-${index}`} className={cls.selectBlock}>
					<div className={cls.leftSelect}>
						<ContainedSelect
							width="100%"
							onSelectChange={(value) => handleSelectChange(value, index, true)}
							value={data.leftSelected}
							options={data.leftOptions || []}
							className={`${cls.select}-${data.leftSelected.value}`}
						/>
					</div>

					<div className={cls.equal}>=</div>

					<div className={cls.rightSelect}>
						<ContainedSelect
							width="100%"
							onSelectChange={(value) => handleSelectChange(value, index, false)}
							value={data.rightSelected}
							options={data.rightOptions || []}
							className={`${cls.select}-${data.rightSelected.value}`}
						/>
					</div>

					<div className={cls.deletBtn}>
						<UniversalButton
							text=""
							buttonStyle="plain"
							icon={<BasketIcon color="#FF0000" width="22" height="22" />}
							handleClick={() => handleRemove(index)}
						/>
					</div>
				</div>
			))}
			<UniversalButton text={`+ ${translate('append', lang)}`} buttonStyle="plain" handleClick={handleAdd} />
		</div>
	);
};

export default DynamicSelects;
